const standardItems = [
  'Süre üzerinden hizmet',
  'Alan görülmeden paket',
  'İş tamamlanmadan süre bitebilir',
];

const viaypiiItems = [
  'Alan önce değerlendirilir',
  'İhtiyaca uygun ekip belirlenir',
  'Profesyonel ekipman planlanır',
  'Yapılacak işin kapsamına göre teklif hazırlanır',
];

const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function Difference() {
  return (
    <section className="bg-warm-white py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20cleaning%20team%20in%20navy%20uniforms%20working%20in%20luxury%20modern%20apartment%20with%20marble%20floors%20and%20floor%20to%20ceiling%20windows%2C%20warm%20natural%20light%2C%20editorial%20photography%2C%20premium%20corporate%20service%20aesthetic%2C%20high-end%20residential%20interior&width=800&height=900&seq=difference-section&orientation=portrait"
              alt="Profesyonel VİAYPİİ temizlik ekibi çalışırken"
              className="w-full h-auto rounded-lg object-cover"
            />
          </div>

          <div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-navy leading-tight mb-8 md:mb-10">
              TEMİZLİK HİZMETİNDE<br />
              <span className="text-gold">FARKLI BİR YAKLAŞIM</span>
            </h2>

            <p className="text-navy/70 text-base md:text-lg leading-relaxed mb-8 md:mb-10">
              Her ev, villa, iş yeri veya inşaat sonrası alan aynı değildir. Bu nedenle standart saatlik paketlerle değil, yapılacak işin kapsamına göre hareket ediyoruz.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border border-warm-sand rounded-lg p-5">
                <h3 className="text-navy/50 font-semibold text-sm uppercase tracking-wider mb-4">
                  Standart Saatlik Yaklaşım
                </h3>
                <ul className="space-y-3">
                  {standardItems.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-navy/60 text-sm">
                      <i className="ri-close-line text-red-400 mt-0.5 flex-shrink-0"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-navy rounded-lg p-5">
                <h3 className="text-gold font-semibold text-sm uppercase tracking-wider mb-4">
                  VİAYPİİ Yaklaşımı
                </h3>
                <ul className="space-y-3">
                  {viaypiiItems.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-white/90 text-sm">
                      <i className="ri-check-line text-gold mt-0.5 flex-shrink-0"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-gold/10 border-l-4 border-gold rounded-r-lg p-4 mb-8">
              <p className="text-navy font-semibold text-sm md:text-base">
                Önceliğimiz kaç saat çalışıldığı değil, yapılacak işin doğru şekilde planlanmasıdır.
              </p>
            </div>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gold hover:bg-gold-dark text-navy-dark font-semibold rounded-md transition-colors"
            >
              Alanımı Göster, Teklif Al
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}